import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['group_id', 'Int!'],
]);
export default function DELETE_GROUP() {
  return gql`
    mutation DeleteGroup(${parametersTypeString}) {
      deleteGroup(${parametersAssignString}) {
        ${defaultResponse}
      }
    }
  `;
}
